// @flow

import React from 'react';
import { useTheme } from '@mui/material/styles';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';

import HeaderTopBar from '../HeaderTopBar';
import AppLoadingSpinner from '../SharedComponents/AppLoadingSpinner';
import { useI18n } from '../../contexts/I18nContext';

import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';

type Props = {
  mobileOpen: bool,
  usehandleDrawerToggle: Function
};

const ReferralsHeader = (props: Props) => {
  const {
    usehandleDrawerToggle
  } = props;

  const theme = useTheme();
  const i18n = useI18n();

  return (
    <AppBar
      position="fixed"
      sx={memberHeaderStyles.appBar(theme)}
    >
      <Toolbar
        disableGutters
      >
        <Grid
          container
          direction='column'
        >
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography
              sx={memberHeaderStyles.pageTitle(theme)}
              variant='h3'
            >{i18n.t('Share Neo')}</Typography>
          </HeaderTopBar>
          <Grid
            item
            sx={{
              ...memberHeaderStyles.rowSub(theme),
              ...memberHeaderStyles.bottomBar(theme)
            }}
          />
          <AppLoadingSpinner />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default ReferralsHeader;
